<script lang="ts">
  import { lockedDie } from '../../store';
  import type { DieFace } from '../models/face.type';
  import DieTicks from './die-ticks.svelte';
  import DieIcon from './die-icon.svelte';

  interface Props {
    class?: string;
    // A die face can carry several symbols, so this takes one face or a whole
    // face array.
    dieType?: DieFace | Array<DieFace> | '';
    colour?: string;
    solid?: boolean;
    sizeMod?: number;
    level?: number;
    children?: import('svelte').Snippet;
  }

  let {
    class: clazz = '',
    dieType = '',
    colour = 'blank',
    solid = false,
    sizeMod = 0,
    level = 0,
    children,
  }: Props = $props();

  let dieRender: Array<DieFace> = $derived(Array.isArray(dieType) ? dieType : [dieType as DieFace]);
</script>

<div
  class="
    die
    {clazz || ''}
    {colour}
    size-{sizeMod}
  "
>
  <div class="die-2d face {solid ? 'solid' : 'hollow'}">
    <DieTicks {level}></DieTicks>
    <DieIcon face={dieRender} {sizeMod} />
  </div>

  <div class="slot">
    {@render children?.()}
  </div>
</div>

<style lang="less">
  .die {
    width: calc(var(--dice-size) + var(--dice-gap));
    height: calc(var(--dice-size) + var(--dice-gap));
    border-radius: 4px;
    transition: opacity 0.3s;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;

    &.size-2 {
      width: calc(var(--dice-size) / 2);
      height: calc(var(--dice-size) / 2);
    }
    &.size-1 {
      width: calc(var(--dice-size) / 1.5);
      height: calc(var(--dice-size) / 1.5);
    }

    .die-2d {
      min-width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
    }

    /* .face{
      &.hollow{
        background-color: transparent;
        box-shadow: inset 3px 3px 5px 0 var(--background-colour-dark), inset -3px -3px 5px var(--background-colour-light);
      }
    } */

    &.hidden {
      opacity: 0;
      pointer-events: none;
    }
  }

  .slot {
    position: absolute;
    opacity: 0.75;
    z-index: 1;
  }
</style>
